import React, { useEffect } from 'react';
import MUIModal from '@mui/material/Modal';
import { Icon, Icons } from 'components/Global/Icon/Icon';
import { appPalette } from 'theme/App.palette';
import { useStyles } from './ModalContainer.styles';
import TextRender from 'components/Global/TextRender/TextRender';
import { trackEvent } from 'helpers/Analytics';

const colors = appPalette.colors;

interface IModal {
  closeFunction?: () => void;
  isOpen: boolean;
  title: string;
  displayTitle?: boolean;
  children: JSX.Element;
  className: any;
  modalId?: string;
  isNotReact?: boolean;
  isVideo?: boolean;
  noTracking?: boolean;
  disablePortal?: boolean;
  hideClosingButton?: boolean;
  customZIndex?: number;
  dataTestId?: string;
}

export default function Modal({
  closeFunction,
  isOpen,
  title,
  displayTitle,
  children,
  className,
  modalId,
  isNotReact,
  isVideo,
  noTracking,
  hideClosingButton,
  disablePortal,
  customZIndex,
  dataTestId = 'modalContainer',
}: IModal): JSX.Element {
  const classes = useStyles();
  // In some cases we want to access the navbar
  const customSx = customZIndex
    ? {
        zIndex: customZIndex,
      }
    : undefined;

  useEffect(() => {
    !noTracking &&
      trackEvent({
        label: title,
        category: { includePageName: true, text: 'modal popup' },
        type: 'modal',
      });
  }, [title, noTracking]);

  return (
    <MUIModal
      open={isOpen || false}
      onClose={hideClosingButton ? undefined : closeFunction}
      aria-labelledby='modalHeader'
      aria-describedby='modalDesc'
      disablePortal={disablePortal}
      sx={customSx}
    >
      <div className={className} id={modalId} data-testid={dataTestId}>
        {isNotReact ? (
          <>
            {!hideClosingButton && (
              <button
                aria-label='Close Modal'
                className={`st-icon-button-focus ${classes.close_button} ${
                  isVideo ? classes.video_style : classes.non_react_style
                }`}
                onClick={closeFunction}
              >
                <Icon
                  type={Icons.close}
                  color={isVideo ? colors.white : colors.mid_grey}
                />
              </button>
            )}
          </>
        ) : (
          <div className={`modal-header ${classes.modal_header}`}>
            {displayTitle && (
              <h2
                id='modalHeader'
                className={`acr-caption-13 ${classes.modal_header_title}`}
              >
                <TextRender text={title} />
              </h2>
            )}
            {!hideClosingButton && (
              <button
                aria-label='Close Modal'
                className={`st-icon-button-focus ${classes.close_button} ${classes.regular_style}`}
                onClick={closeFunction}
              >
                <Icon type={Icons.close} color={colors.mid_grey} />
              </button>
            )}
          </div>
        )}
        {children}
      </div>
    </MUIModal>
  );
}
